import React from 'react';
import { Car, Truck, MessageCircle } from 'lucide-react';
import { translations } from '../utils/translations';
interface CarRentalProps {
  lang: string;
}
export function CarRental({
  lang
}: CarRentalProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  const vehicles = [{
    id: 1,
    title: t.sedan,
    desc: t.sedanDesc,
    icon: <Car className="w-12 h-12 text-brand-red mb-4" data-id="element-3" />
  }, {
    id: 2,
    title: t.suv,
    desc: t.suvDesc,
    icon: <Car className="w-12 h-12 text-brand-red mb-4" data-id="element-4" />
  }, {
    id: 3,
    title: t.truck,
    desc: t.truckDesc,
    icon: <Truck className="w-12 h-12 text-brand-red mb-4" data-id="element-5" />
  }];
  return <section className="py-20 px-4 bg-brand-dark w-full" data-id="element-6">
      <div className="max-w-6xl mx-auto" data-id="element-7">
        <div className="text-center mb-12" data-id="element-8">
          <h2 className="text-4xl md:text-5xl text-white mb-4" data-id="element-9">
            {t.rentalTitle}
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto" data-id="element-10"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-11">
          {vehicles.map(v => <div key={v.id} className="bg-brand-black border border-gray-800 p-8 rounded-lg hover:border-brand-red transition-colors group" data-id="element-12">
              <div className="flex flex-col items-center text-center" data-id="element-13">
                <div className="transform group-hover:scale-110 transition-transform duration-300" data-id="element-14">
                  {v.icon}
                </div>
                <h3 className="text-2xl text-white mb-3" data-id="element-15">{v.title}</h3>
                <p className="text-gray-400 font-body leading-relaxed" data-id="element-16">
                  {v.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-17">
          <a href="https://wa.link/7opyfb" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full md:w-auto px-8 h-14 bg-[#25D366] hover:bg-[#128C7E] text-white text-lg font-heading tracking-wider rounded-md transition-colors" data-id="element-18">
            <MessageCircle className="w-6 h-6 mr-3" data-id="element-19" />
            {t.whatsappCTA}
          </a>
        </div>
      </div>
    </section>;
}